module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-227f3d93.png";